import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    playerPointsModal: false,
    playerId:null,
    matchFixtureId:null
}

const playerPointsModalSlice = createSlice({
    name: "playerPointsModalSlice",
    initialState,
    reducers: {
        togglePlayerPointsModal: (state, action) => {
            state.playerPointsModal = !state.playerPointsModal;
            state.playerId=action.payload?.playerId;
            state.matchFixtureId=action.payload?.matchFixtureId;
            return state;
        },
    }

});

export const { togglePlayerPointsModal } = playerPointsModalSlice.actions;
export default playerPointsModalSlice;